import { WatchQueryFetchPolicy } from '@apollo/client';
import {
  LanguageId,
  useArticleTranslationQuery,
} from 'lib-knowledge-management-common/graphql';

type UseTranslationFetchReturnValue = ReturnType<
  typeof useArticleTranslationQuery
>;

export function useTranslationFetch({
  articleId,
  languageId,
  fetchPolicy = 'cache-and-network',
}: {
  articleId: string;
  languageId: LanguageId | null;
  fetchPolicy?: WatchQueryFetchPolicy;
}): UseTranslationFetchReturnValue {
  return useArticleTranslationQuery({
    variables: {
      id: articleId,
      languageId: languageId!,
    },
    skip: !articleId || !languageId,
    fetchPolicy,
  });
}
